// # Admin Leaderboards Component
import React, { useState, useEffect } from 'react';
import { FaTrophy } from 'react-icons/fa';
import './admin_leaderboards.css';
import DashboardHeader from '../../../../components/DashboardHeader';
import DashboardFooter from '../../../../components/DashboardFooter';
import { auth, db } from '../../../../auth/firebase';
import { doc, updateDoc } from 'firebase/firestore';
import cacheManager from '../../../../auth/cache_manager';

function AdminLeaderboards() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // # Load theme preference from user data on initial render
  useEffect(() => {
    const loadThemePreference = async () => {
      if (auth.currentUser?.uid) {
        // # Try to get from cache first
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData && userData.themes && userData.themes.gen_theme !== undefined) {
          setIsDarkMode(userData.themes.gen_theme === 'dark');
        }
      }
    };
    
    loadThemePreference();
  }, []);

  // # Handle theme toggle
  const handleThemeToggle = async () => {
    try {
      const newTheme = !isDarkMode;
      setIsDarkMode(newTheme);
      
      // # Update theme in Firebase if user is logged in
      if (auth.currentUser?.uid) {
        // # Update the user document
        await updateDoc(doc(db, 'users', auth.currentUser.uid), {
          'themes.gen_theme': newTheme ? 'dark' : 'light'
        });
        
        // # Update cache manager
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData) {
          const updatedUserData = {
            ...userData,
            themes: {
              ...(userData.themes || {}),
              gen_theme: newTheme ? 'dark' : 'light'
            }
          };
          cacheManager.set(`user_${auth.currentUser.uid}`, updatedUserData);
        }
      }
    } catch (error) {
      console.error('Error updating theme preference:', error);
    }
  };

  // # Define the leaderboard sections
  const leaderboardSections = [
    {
      title: 'The Big Board',
      icon: <div className="admin_leaderboards_trophy_icon">
              <FaTrophy size={24} />
            </div>,
      description: 'Overall platform leaderboard',
      comingSoon: true
    },
    {
      title: 'Mentorship Step 1 Board',
      icon: '/icons/dash/one.png',
      description: 'Step 1 mentorship performance tracking',
      comingSoon: true
    },
    {
      title: 'Mentorship Step 2 Board',
      icon: '/icons/dash/two.png',
      description: 'Step 2 mentorship performance tracking',
      comingSoon: true
    }
  ];

  return (
    <div className={`admin_leaderboards_container ${isDarkMode ? 'admin_leaderboards_dark-mode' : ''}`}>
      <DashboardHeader isDarkMode={isDarkMode} onThemeToggle={handleThemeToggle} />
      
      <div className="admin_leaderboards_content">
        <h1 className="admin_leaderboards_title">Leader Boards</h1>
        
        <div className="admin_leaderboards_grid">
          {leaderboardSections.map((section, index) => (
            <div key={index} className="admin_leaderboards_card">
              <div className="admin_leaderboards_card_header">
                {typeof section.icon === 'string' ? (
                  <div className="admin_leaderboards_icon_wrapper">
                    <img src={section.icon} alt={section.title} className="admin_leaderboards_icon" />
                  </div>
                ) : (
                  section.icon
                )}
                <h2>{section.title}</h2>
              </div>
              <p>{section.description}</p>
              {section.comingSoon && (
                <div className="admin_leaderboards_coming_soon">
                  Coming Soon
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <DashboardFooter isDarkMode={isDarkMode} />
    </div>
  );
}

export default AdminLeaderboards; 